/*
 * PDE - JavaScript
 * Copyright 2010. All rights reserved.
 *
 * Class: Number
 * Description: New features to native js class
 */
Number.implement(
{
	// Adds comma for every 3 digits.	Works only for Integers.
	'commas': function()
	{
		var tokens, str = [];
		tokens = this.toString().split("").reverse();
		tokens.each(function(token, i)
		{
			if (i > 0 && (i%3 == 0))
			{
				str.push(',');
			}
			str.push(token);
		});
		return str.reverse().join('');
	}
});